import QuestionModal from './QuestionModal'

export default QuestionModal
